<template>
    <HomeLayout>
        <template v-if="loading">
            <ProgressPage/>
        </template>
        <template v-else>
            <div class="container plans">
              <div class="">
                <div class="Subscription ">
                  <div class="d-flex flex-column align-items-center" v-if="plan === null">
                    <p class="SubscriptionTitle">
                      شما در حال حاضر هیچ اشتراکی ندارید
                    </p>
                    <p class="SubscriptionText m-0">
                      برای ادامه دسترسی به جالیزان وِدِر یکی از اشتراک های زیر را انتخاب نمایید.
                    </p>
                  </div>
                  <div class="d-flex flex-column align-items-center" v-else>
                    <div>
                      <p class="SubscriptionOption mb-0">
                        {{ plan.message }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="SubscriptionList">
                  <div class=" mb-3">
                    <p class="SubscriptionText">
                      انواع اشتراک
                    </p>
                  </div>
                  <div class="plans-wrapper">
                    <div class="plan-box position-relative p-0"
                         v-for="item in plans"
                         :key="item.id"
                         :class="{ active: item.default }">
                      <div class="header-box position-relative">
                        <p class="mb-3 name">{{ item.name }}</p>
                        <div class="price-box d-flex align-items-baseline gap-2">
                          <p class="text-nowrap"> {{ item.price.toLocaleString() }} <span style="font-size: 18px">تومان</span></p>
                          <span class="interval">/</span>
                          <span class="interval text-nowrap"> {{ item.description }}</span>
                        </div>

                        <span class="interval-box position-absolute"> {{ item.invoice_period }} {{ item.fa_invoice_interval }}</span>

                        <div @click="buyPlans(item.id)"
                             class="buy-plan text-center mt-4 d-flex justify-content-between align-items-center">
                          <span>خرید اشتراک</span>

                          <div class="d-flex align-items-center gap-1">
                            <p class="text-nowrap"> {{ item.total_price.toLocaleString() }} <span>تومان</span></p>
                          </div>
                        </div>
                      </div>
                      <div class="features-box d-flex flex-column gap-3 py-4">
                        <div v-for="(feature, index) in item.features"
                             :key="index">
                          <div class="d-flex gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 class="flex-shrink-0" width="18" height="18"
                                 viewBox="0 0 20 20"><path fill="#29bb89" d="M8.294 16.998c-.435 0-.847-.203-1.111-.553L3.61 11.724a1.39 1.39 0 0 1 .27-1.951a1.39 1.39 0 0 1 1.953.27l2.351 3.104l5.911-9.492a1.396 1.396 0 0 1 1.921-.445c.653.406.854 1.266.446 1.92L9.478 16.34a1.39 1.39 0 0 1-1.12.656z"/></svg>
                           <div>
                             <p class="mb-0">{{ feature.name }} <span v-if="feature.description" class="mb-0 description">({{ feature.description }})</span></p>
                           </div>
                          </div>
                        </div>
                      </div>
<!--                      <div class="position-absolute monthly-price" v-if="item.monthly_price_show === true">ماهانه-->
<!--                        {{ item.monthly_price.toLocaleString() }} تومان-->
<!--                      </div>-->
<!--                      <div class="row " v-if="item.slug !== 'free'">-->
<!--                        <div class="col-6 text-right pt-2">-->
<!--                                                                  <span class="monthly-indicator d-inline-block py-1"-->
<!--                                                                        :style="{ backgroundColor: item.monthly_price_show_color }">-->
<!--                                                                      {{ item.invoice_month_number }}-->
<!--                                                                  </span>-->
<!--                          <span class="text-bold pe-3">-->
<!--                                                                    {{ item.name }}-->
<!--                                                                  </span>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;                                      invoice_period&ndash;&gt;-->
<!--                        <div class="col-6 text-left">-->
<!--                                                                  <span v-if="item.price !== item.original_price"-->
<!--                                                                        style="text-decoration: line-through"-->
<!--                                                                        class="text-muted ps-2 small">-->
<!--                                                                      {{ item.original_price.toLocaleString() }} تومان-->
<!--                                                                  </span>-->
<!--                          <button class="btn SubscriptionListButton" @click="buyPlans(item.id)">-->
<!--                            <strong> {{ item.price.toLocaleString() }}</strong>-->
<!--                            <span>تومان</span>-->
<!--                            <span v-if="item.invoice_month_number != 0">/هکتار</span>-->
<!--                            <span v-else-if="item.invoice_month_number == 0">/مشاوره</span>-->
<!--                          </button>-->
<!--                        </div>-->
<!--                        <small class="pe-5" v-if="item.description">&nbsp;&nbsp;({{ item.description }})</small>-->
<!--                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </template>
    </HomeLayout>
</template>

<script>
import HomeLayout from "../layout/HomeLayout";
import {globalMixin} from "@/mixins/globalMixin";
import Api from "../common/api";
import ProgressPage from "../components/UI/ProgressPage";

export default {
    name: "Subscription",
    components: {ProgressPage, HomeLayout},
    mixins: [globalMixin],
    inject: ["$axios"],
    data() {
        return {
            plan: {},
            plans: [],
        };
    },
    methods: {
        SubscriptionData() {
            let self = this;
            Api.getSubscriptionApi({self: this})
                .then((response) => {
                    if (response.status === 200) {
                        let data = response.data;
                        this.loading = false;
                        this.plan = data.plan;
                    }
                })
                .catch((error) => {
                    self.handleError(self, error);
                });
            Api.getMyPlansListSubscriptionApi({self: this})
                .then((response) => {
                    if (response.status === 200) {
                        let data = response.data;
                        this.loading = false;
                        this.plans = data;
                    }
                })
                .catch((error) => {
                    self.handleError(self, error);
                });
        },
        buyPlans(planId) {
            // let self = this;
            this.loading = true;
            Api.getBuySubscriptionApi({self: this, id: planId})
                .then((response) => {
                    if (response.status === 200) {
                        //uncomment for payping gateway
                        // window.location = response.data.action ;

                        // use for sep gateway
                        // Create a new window or tab
                        let paymentWindow = window.open('', '_blank');

                        // Check if the window is successfully opened
                        if (paymentWindow) {
                            // Create a form element
                            let form = document.createElement('form');
                            form.method = 'POST';
                            form.action = response.data.action; // URL to the payment gateway
                            console.log(response.data.action);
                            // Create an input element for the token
                            let tokenInput = document.createElement('input');
                            tokenInput.type = 'hidden';
                            tokenInput.name = 'Token';
                            tokenInput.value = response.data.inputs.Token; // Assuming the token is in response.data.token

                            // Append the token input to the form
                            form.appendChild(tokenInput);

                            // Append the form to the new window's document body
                            paymentWindow.document.body.appendChild(form);

                            // Submit the form
                            form.submit();
                        } else {
                            console.error('Popup blocked or failed to open');
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                    // self.handleError(self, error);
                });
        },
    },
    created() {
        this.loading = true;
    },
    mounted() {
        this.SubscriptionData();
    },
};
</script>

<style lang="scss">
@import "src/styles/modules/Subscription/Subscription";
</style>
